const notificationEnumerators = {
  status: [
    'viewed',
    'pending',
    'clicked',
    'info',
    'finished',
  ],
  relatedTo: ['resource', 'asset', 'location'],
};

export default notificationEnumerators;
